var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h14v14H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M111.864 39.824a3.668 3.668 0 0 1-3.26 2.235c-.178 0-2.957.147-6.951-3.643a11.084 11.084 0 0 1-3.641-6.953c-.033-.607.14-2.13 2.234-3.261.259-.14.774-.2.907-.069.059.059 1.817 2.952 1.863 3.048a.646.646 0 0 1 .069.282.822.822 0 0 1-.282.5 4.82 4.82 0 0 1-.614.545 5.969 5.969 0 0 0-.614.525.755.755 0 0 0-.282.456c.013.309.266 1.414 2.191 3.106a14.806 14.806 0 0 0 2.943 2.2.67.67 0 0 0 .223.049.754.754 0 0 0 .456-.282c.185-.188.807-1.041 1-1.229a.823.823 0 0 1 .5-.282.645.645 0 0 1 .282.069c.1.046 2.992 1.741 3.047 1.8.15.154.044.635-.069.907",
    transform: "translate(-98.008 -28.059)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.ece3a7cdb01e8fad9be7fc7d40381f14.svg";
export { ForwardRef as ReactComponent };